import React, { useState } from "react";
import { UserListItem } from "@beable/roster-backend-client-v1";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { getStyles } from "./styles";

interface UserTableProps {
  teachers: UserListItem[];
  students: UserListItem[];
  admins: UserListItem[];
  onUserClick: any;
}

export default function UsersTable(props: UserTableProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [selectedUser, setSelectedUser] = useState<UserListItem | undefined>(
    undefined
  );

  const handleSelectedUser = async (
    user: UserListItem,
    event: any,
    role?: string
  ) => {
    setSelectedUser(user);
    props.onUserClick(user.id, event, role);
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">First Name</TableCell>
            <TableCell align="left">Last Name</TableCell>
            <TableCell align="left">Role</TableCell>
            <TableCell align="left">Grade</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.teachers.map((teacher: UserListItem, index: number) => (
            <TableRow
              selected={selectedUser && selectedUser.id === teacher.id}
              sx={styles.clickable}
              key={index}
              onClick={(e: any) => {
                handleSelectedUser(teacher, e);
              }}
            >
              <TableCell align="left">{teacher.firstName}</TableCell>
              <TableCell align="left">{teacher.lastName}</TableCell>
              <TableCell align="left">teacher</TableCell>
              <TableCell align="left">N/A</TableCell>
            </TableRow>
          ))}
          {props.students.map((student: UserListItem, index: number) => (
            <TableRow
              selected={selectedUser && selectedUser.id === student.id}
              sx={styles.clickable}
              key={index}
              onClick={(e: any) => handleSelectedUser(student, e)}
            >
              <TableCell align="left">{student.firstName}</TableCell>
              <TableCell align="left">{student.lastName}</TableCell>
              <TableCell align="left">student</TableCell>
              <TableCell align="left">{student.grade}</TableCell>
            </TableRow>
          ))}
          {props.admins.map((admin: UserListItem, index: number) => (
            <TableRow
              selected={selectedUser && selectedUser.id === admin.id}
              sx={styles.clickable}
              key={index}
              onClick={(e: any) => handleSelectedUser(admin, e, admin.role)}
            >
              <TableCell align="left">{admin.firstName}</TableCell>
              <TableCell align="left">{admin.lastName}</TableCell>
              <TableCell align="left">admin</TableCell>
              <TableCell align="left">N/A</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
